import { createFileRoute } from '@tanstack/react-router'
import { MailLinkFallback } from './-components/mail-link-fallback'
import {
	buildMailLinkSeo,
	mailLinkSearchSchema
} from './-lib/mail-link-fallback'

export const Route = createFileRoute('/(public)/invite')({
	ssr: true,
	validateSearch: mailLinkSearchSchema,
	head: ({ match }) =>
		buildMailLinkSeo({
			appLanguage: match.context.appLanguage,
			flow: 'invite',
			path: '/invite'
		}),
	component: InviteFallback
})

function InviteFallback() {
	const { appLanguage } = Route.useRouteContext()
	const search = Route.useSearch()
	return (
		<MailLinkFallback
			appLanguage={appLanguage}
			flow='invite'
			proof={search.ref ?? search.token}
		/>
	)
}
